import type { TelemetryReportData, TransmissionOptions } from '../../types';

export enum CoreReportType {
  Event = 'event',
  Failure = 'failure',
  Duration = 'duration',
  Search = 'search',
  Translation = 'translation',
}

export interface CoreTransmissionOptions extends TransmissionOptions {
  /** Boolean or a hashing function to identify report. If hashing function will be passed report will be sent only once using return value as report hash */
  once?: boolean | (() => string);
}

export interface CoreTelemetryReportData extends Partial<Omit<TelemetryReportData, 'type'>> {}
